<template>
  <div>
    <v-select
      v-if="companies.length > 0"
      :items="companies"
      label="Switch Company"
      v-model="selectedCompanyEmis"
      item-text="name"
      item-value="emis"
      @change="getSelectedCompany()"
    ></v-select>
  </div>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: ["userId"],
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    itsBitsems() {
      return this.$store.getters.itsBitsems;
    },
  },
  data: () => ({
    companies: [],
    selectedCompanyEmis: "",
  }),
  mounted() {
    axios
      .postDataWithToken(
        "/auth/get-user-companies-with-access",
        { userId: this.userId },
        this.getAccessToken
      )
      .then((companies) => {
        this.companies = companies.sort();
        // this.companies.unshift({
        //   name: "Create Own Company..",
        //   emis: "091091091",
        // });
      });
  },
  methods: {
    getSelectedCompany() {
      this.$store.commit("setLoader", true);
      if (this.selectedCompanyEmis == "091091091") {
        this.$store.commit("setLoader", false);
        this.$router.push({ name: "create-company" });
      } else {
        axios
          .postDataWithToken(
            "/auth/get-selected-company",
            { emis: this.selectedCompanyEmis },
            this.getAccessToken
          )
          .then((data) => {
            this.$store.commit("setUserCompany", data.company);
            this.$store.commit("setCurrency", data.currency);
            this.$store.commit("setCompanyLabels", data.labels);
            this.$store.commit("setThemeColor", data.company.primary_bg_color);
            this.$store.commit(
              "setSecondaryColor",
              data.company.secondary_bg_color
            );
            this.$store.commit("setAppName", data.company.name);
            this.$store.commit("setCurrentUser", data.user);

            localStorage.setItem("themeColor", data.company.primary_bg_color);
            localStorage.setItem(
              "secondaryColor",
              data.company.secondary_bg_color
            );
            localStorage.setItem("appName", data.company.name);
            localStorage.setItem("userCompany", JSON.stringify(data.company));
            localStorage.setItem("companyLabels", JSON.stringify(data.labels));

            this.$store.commit("setLoader", false);
            // this.$router.push({ name: "switchboard" });
            if (window.location.pathname == "/switchboard") {
              this.$emit("company-switched", data.company);
              const something = "nothing";
            } else {
              this.$router.push({ name: "switchboard" });
            }
          }); //End of then
      }
    },
  },
};
</script>

<style></style>
